/**
 * Created by Balazs Foldesi on 2017. 11. 27.
 */

import '../c/appid_DNFORM.pcss';
import 'jquery';
import angular from 'angular';
import 'angular-messages';
import 'angular-cookies';
import './lib/jquery-ui';
import './lib/datepicker-design-select';
import './lib/ui-datepicker-hu';
import './lib/date';
import './lib/design-select';
import 'angular-recaptcha';

import coreController from './controller/dyna-form-core-controller';
import thankYouController from './controller/dyna-thank-you-controller';
import dynaFactory from './factory/dyna-form-factory';
import scrollToFirstError from './directive/scroll-to-first-error';
import multiSelect from './directive/multi-select';
import numbersOnly from './directive/numbers-only';
import emailValidator from './directive/email-validator';
import designSelect from './directive/design-select';
import datepickerDesignSelect from './directive/datepicker-design-select';
import captcha from './directive/captcha';
import checkboxGroup from './directive/checkbox-group';
import radioButtons from './directive/radio-buttons';
import placeholderCheck from './directive/placeholder-validator';
import thankYouData from './directive/thank-you-data';
import numberInputResetParsers from './directive/number-input-reset-parsers';
import jumpToGlobalError from './directive/jump-to-global-error';
import storgeFactory from './factory/storge-factory';
import taxFilter from './filter/tax-filter';
const app = angular.module('DynaFormCore', ['ui.date', 'ngMessages', 'vcRecaptcha', 'ngCookies']);
window.$DynaFormCore = app;

// Filters
app.filter('taxNumber', taxFilter);

// Factories
app.factory('dynaFormFactory', dynaFactory);
app.factory('storgeFactory', storgeFactory);

// Controllers
app.controller('coreController', coreController);
app.controller('thankYouController', thankYouController);

// Directives
app.directive('scrollToFirstError', scrollToFirstError);
app.directive('multiSelect', multiSelect);
app.directive('numbersOnly', numbersOnly);
app.directive('emailValidator', emailValidator);
app.directive('designSelect', designSelect);
app.directive('datepickerDesignSelect', datepickerDesignSelect);
app.directive('captcha', captcha);
app.directive('checkboxGroup', checkboxGroup);
app.directive('radioButtons', radioButtons);
app.directive('placeholderCheck', placeholderCheck);
app.directive('thankYou', thankYouData);
app.directive('numberInputResetParsers', numberInputResetParsers);
app.directive('jumpToGlobalError', jumpToGlobalError);
